<template>
  <instructions-component
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Instructions } from '@powerplay/core-minigames-ui'
import {
  CorePhases,
  corePhasesManager,
  modes,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssets } from '@/globals/globalvariables'
import { blurState } from '@/stores'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponent: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions(): {imgSrc: string, header: string, text: string[]}[] {

      blurState().isActive = true

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssets}/ui/instructions/training-1.png?3`,
            header: this.$t('instructionsDisciplineTraining3Cell1Title'),
            text: [this.$t('instructionsDisciplineTraining1Cell1Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-2.png?3`,
            header: this.$t('instructionsDisciplineTraining3Cell2Title'),
            text: [this.$t('instructionsDisciplineTraining3Cell2Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-3.png?3`,
            header: this.$t('instructionsDisciplineTraining3Cell3Title'),
            text: [this.$t('instructionsDisciplineTraining3Cell3Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-4.png?3`,
            header: this.$t('instructionsDisciplineTraining3Cell4Title'),
            text: [this.$t('instructionsDisciplineTraining3Cell4Text1')]
          }
        ]

      }

      return [
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-1.png?3`,
          header: this.$t('instructionsDiscipline3Cell1Title'),
          text: [
            this.$t('instructionsDiscipline3Cell1Text1'),
            this.$t('instructionsDiscipline3Cell1Text2')
          ]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-2.png?3`,
          header: this.$t('instructionsDiscipline3Cell2Title'),
          text: [this.$t('instructionsDiscipline3Cell2Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-3.png?3`,
          header: this.$t('instructionsDiscipline3Cell3Title'),
          text: [this.$t('instructionsDiscipline3Cell3Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-4.png?3`,
          header: this.$t('instructionsDiscipline3Cell4Title'),
          text: [this.$t('instructionsDiscipline3Cell4Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-5.png?3`,
          header: this.$t('instructionsDiscipline3Cell5Title'),
          text: [this.$t('instructionsDiscipline3Cell5Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-6.png?3`,
          header: this.$t('instructionsDiscipline3Cell6Title'),
          text: [this.$t('instructionsDiscipline3Cell6Text1')]
        }
      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually()

    }
  }

})
</script>

<style lang="less" scoped>
.instruciton-card-photo{
    width: 343px;
    height: 229px;
}
</style>
